import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { FAQ as MLBFAQ } from '@sorare/baseball/src/components/faq';
import { FAQ as FootballFAQ } from '@sorare/football/src/components/faq';
import { FAQ as NBAFAQ } from '@sorare/nba/src/components/faq';
import { InfoLayout } from 'components/layouts/InfoLayout';

const StyledFAQ = styled.div`
  margin-top: 2em;
`;

const FAQ = () => {
  const { sport: sportContext } = useSportContext();

  const faq = {
    [Sport.FOOTBALL]: <FootballFAQ />,
    [Sport.NBA]: <NBAFAQ />,
    [Sport.BASEBALL]: <MLBFAQ />,
  };

  return (
    <InfoLayout>
      <StyledFAQ>{faq[sportContext]}</StyledFAQ>
    </InfoLayout>
  );
};

export default FAQ;
